import { ChatMiddlewareType } from '@indigohive/cogfy-types'
import { ChatMiddlewareDataFormProps } from './ChatMiddlewareDataFormProps'
import { RetrievalForm } from './subcomponents/RetrievalForm'
import { ToolForm } from './subcomponents/ToolForm'

const COMPONENTS_BY_MIDDLEWARE_TYPE: Partial<Record<ChatMiddlewareType, typeof RetrievalForm>> = {
  retrieval: RetrievalForm,
  tool: ToolForm
}

export function ChatMiddlewareDataForm (props: ChatMiddlewareDataFormProps) {
  const { type } = props

  const CustomComponent = COMPONENTS_BY_MIDDLEWARE_TYPE[type]

  return (
    <>
      {CustomComponent && <CustomComponent {...props} />}
    </>
  )
}
